import { useContext, useEffect, useState } from 'react';
import { TabContext } from '../../../Context/TabContext';
import { urls } from './api/urls';
import useHttp from '../../../hooks/use-http';
import { formatDateBody, formatDateFromDB } from '../../../../utils/FormatDate';
import Field from './components/Field/Field';
import DragAndDrop from '../../UI/DragAndDrop';
import { convertBase64ToFile } from '../../../../utils/convertBase64ToFile';
import { useTranslation } from 'react-i18next';

const INITIAL_VALUES = {
  id: 0,
  ceoBrDok: '',
  datum: formatDateBody(new Date()),
  idMasine: null,
  nazivMasine: '',
  idVeze: null,
  ukupanIznos: 0.0,
  napomena: '',
  files: [],
  base64: '',
  brZahteva: '',
  nazivTipaMasine: '',
};
const PonudeDetalji = () => {
  const { t, i18n } = useTranslation();
  const { tabsData, activeComponent, onTabChange } = useContext(TabContext);
  const dataLocal = tabsData.find((item) => item.type === activeComponent);
  const ponudaLocal = dataLocal?.data ? dataLocal?.data : null;

  const { getData } = useHttp('');

  const [formValue, setFormValue] = useState(INITIAL_VALUES);
  const [naziv, setNaziv] = useState('');
  const [tip, setTip] = useState('');

  const VratiPonudu = async (id, idReda) => {
    let idDok = 0;
    let base64 = '';
    let nazivFajla = '';
    let tipFajla = '';
    const config = {
      method: 'POST',
      url: urls.GET_PONUDE_ID,
      data: { id: id },
    };
    const response = await getData(config);
    if (response?.id) {
      console.log('ponude response', response);
      // setFormValue({ ...response, id: response.idDok, files: [] });
      idDok = response.idDok;
      nazivFajla = response.name;
      tipFajla = response.type;
      setNaziv(response.name);
      setTip(response.type);
      //   setOpenDialog(true);
    }

    const config2 = {
      method: 'POST',
      url: urls.KONVERTOVANJE_BASE_64,
      data: { id: idReda },
    };
    const response2 = await getData(config2);
    // // console.log(response2);
    if (response2 !== 'Nema dokumenta!') {
      base64 = response2;

      const fileName = nazivFajla;
      const fileType = tipFajla;

      const file = convertBase64ToFile(base64, fileName, fileType);

      setFormValue({ ...response, id: idDok, files: [file] });
    } else if (response2 === 'Nema dokumenta!') {
      setFormValue({ ...response, id: idDok, files: [] });
    } else {
      toast.error('Greška!');
    }
  };

  useEffect(() => {
    if (ponudaLocal?.pregledMasina) {
      VratiPonudu(
        ponudaLocal.pregledMasina.idDok,
        ponudaLocal.pregledMasina.id,
      );
    }
  }, []);
  useEffect(() => {
    console.log(formValue);
  }, [formValue]);

  return (
    <div>
      <Field label={t('offerNumber')} value={formValue.ceoBrDok} />
      <Field label={t('requestNumber')} value={formValue.poDokumentu} />
      <Field label={t('date')} value={formatDateFromDB(formValue.datum)} />
      <Field
        label={
          formValue.nazivTipaMasine
            ? t(formValue.nazivTipaMasine)
            : t('robot/mold')
        }
        value={formValue.nazivMasine}
      />
      <Field label={t('totalAmount')} value={formValue.ukupanIznos} />
      <Field label={t('note')} value={formValue.napomena} />
      <DragAndDrop
        // handleFiles={handleFiles}
        enableAddFiles={false}
        // enableDelete={false}
        maxFiles={1}
        addedFiles={formValue.files}
        showBtnOnlyAdmin={localStorage.idFirme !== '1'}
        // handleRemoveFile={handleDeleteFile}
      />
    </div>
  );
};

export default PonudeDetalji;
